import { useUIUtilsContext } from '@lumahealthhq/ui-utils';
import useModelContext from './useModelContext';
export default function useAxiosClient() {
  const context = useUIUtilsContext();
  const axiosClientDeprecated = useModelContext(s => s.axiosClient);
  const axiosClient = (context == null ? void 0 : context.axiosClient) || axiosClientDeprecated;
  if (!axiosClient) {
    throw new Error('"axiosClient" is missing');
  }
  return axiosClient;
}